
export default {
  props: {
    iconProp: {
      type: String,
      default: "mdi-pencil-outline"
    }
  },
  methods: {
    handleBtnClick() {
      this.$emit("show-options-tile");
    }
  }
};
